import Tooltip from "../../common/StyledToolTip";
import ToolTipWithScroll from '../../common/StyledToolTipWithScroll';
import { withStyles, withTheme } from "@material-ui/core";
import appConstant from "../../../appConstants";
import { getSvgIcons } from "../../modules/Dispatch/utils/svgIcons";
import { compose } from "recompose";

const styles = () => ({
  iconsContainer: {
    display: "flex",
    alignItems: "center",
    height: "100%",
  },
  iconStyle: {
    marginRight: 5,
  },
});

export const getCombinedIcons = (params, options) => {
  const specialNeeds = {};
  if (Array.isArray(params.value) && params.value.length > 0) {
    const SpecailNeedsList = options || appConstant.SpecialNeeds;
    SpecailNeedsList.forEach((data) => (specialNeeds[data.value] = data));
    return getCombinedIconArray(params, specialNeeds);
  }
  return [];
};

const renderSpecialInstructions = (specialInstructions) => {
  return (
    <>
      <span>{specialInstructions}</span>
      <br />
    </>
  );
};

const getSpecialInstructionForDeliveryStop = (stopData) => {
  return stopData.shipments.reduce((allSpecialInstructions, shipment) => {
    if (shipment.specialInstructions) {
      return [...allSpecialInstructions, renderSpecialInstructions(shipment.specialInstructions)]
    }
    return allSpecialInstructions;
  }, [])
}

const getIconType = (specialNeedObject) => {
  return (specialNeedObject.icon || specialNeedObject.svgIcon || "")
}

const getCombinedIconArray = (params, specialNeeds) => {
  const combinedIconsArray = [];
  params.value.forEach((value) => {
    const iconDetails = specialNeeds[value];
    const iconValue = iconDetails ? getIconType(iconDetails) : "";
    const isSvgIcon = Boolean(iconDetails?.svgIcon) ?? false;
    if (value === appConstant.SpecialNeedsStrings.APT) {
      const aptWindow = params.getAPTWindow?.(params) ?? params.data.deliveryWindow 
      combinedIconsArray.push({
        icon: iconValue,
        isSvgIcon,
        tooltip: aptWindow
          ? `${appConstant.SpecialNeedsStrings.APT} from ${aptWindow}`
          : appConstant.SpecialNeedsStrings.APT,
      });
    } else if (value === appConstant.SpecialNeedsStrings.SI) {
      //we are not showing specialInstruction for route
      if (params.data.stopType === appConstant.STOP_TYPE.Delivery && params.data.shipments?.length) {
        combinedIconsArray.push({
          icon: iconValue,
          isSvgIcon,
          tooltip: getSpecialInstructionForDeliveryStop(params.data),
        });
      } else {
        combinedIconsArray.push({
          icon: iconValue,
          isSvgIcon,
          tooltip:
            params.data.specialInstruction ||
            params.data.specialInstructions ||
            params.data.shipmentSpecialInstruction,
        });
      }
    }else if (value === appConstant.SpecialNeedsStrings.CC) {
      combinedIconsArray.push({
        icon: iconValue,
        isSvgIcon,
        tooltip:
          params.data.customerComments || //shipment grid
          params.data.deliveryDetails?.customerComments, //customer/shipper grid
        toolTipWithScroll: true,
      });
    } else if (value === appConstant.SpecialNeedsStrings.SC) {
      combinedIconsArray.push({
        icon: iconValue,
        isSvgIcon,
        tooltip:
          params.data.shipperComments || //shipment grid
          params.data.pickupDetails?.shipperComments, //customer/shipper grid
        toolTipWithScroll: true,
      });
    } else {
      combinedIconsArray.push({
        icon: iconValue,
        isSvgIcon,
        tooltip: iconDetails ? iconDetails.tooltip : "",
      });
    }
  });
  return combinedIconsArray;
};

const SpecialNeedsRenderer = (params) => {
  const options = params.context?.specialNeedsOptions;
  const { classes, theme } = params;
  const iconsList = getCombinedIcons(params, options);
  if (iconsList.length === 0) {
    return null;
  }
  const getIcon = (icons) => {
    if (icons.isSvgIcon) {
      return getSvgIcons(icons.icon, theme.iconColor);
    }
    return <i className={`${icons.icon}`} />;
  };
  return (
    <div className={classes.iconsContainer}>
      {iconsList.map((icons, index) => {
        const TooltipComponent = icons.toolTipWithScroll ? ToolTipWithScroll : Tooltip;
        return (
          <TooltipComponent key={index} title={icons.tooltip} >
            <div className={classes.iconStyle}>{getIcon(icons)}</div>
          </TooltipComponent>
        );
      })}
    </div>
  );
};

export default compose(withStyles(styles), withTheme())(SpecialNeedsRenderer);
